import * as t from "io-ts"

import {
    ApplicationSpec,
    FixedInputs,
    IApplicationForms,
    IApplicationStepIndexMap,
    IFormTitlesIndexMap,
} from "../singleApplication/getSchemaTypes"

const FormData = t.record(
    t.string,
    t.union([
        t.record(t.string, t.unknown),
        t.array(t.record(t.string, t.unknown)),
    ])
)

const SupplementingInfo = t.record(t.string, t.unknown)

export const LaunchAmendmentRaw = t.strict({
    devicesNotFound: t.array(t.string),
    lcts: t.array(t.string),
    fixedInputs: FixedInputs,
    formData: FormData,
    rawApplicationSpec: ApplicationSpec,
    supplementingInfo: SupplementingInfo,
})

export type ISupplementingInfo = t.TypeOf<typeof SupplementingInfo>

export type ILaunchAmendmentRaw = t.TypeOf<typeof LaunchAmendmentRaw>

export type IFormData = t.TypeOf<typeof FormData>

// Extended to include the fields derived from the raw spec
export type ILaunchAmendmentMapped = ILaunchAmendmentRaw & {
    formTitlesIndexMap: IFormTitlesIndexMap
    applicationStepIndexMap: IApplicationStepIndexMap
    applicationForms: IApplicationForms
}
